Ext.define('SA.HistogramNoDataView', {
    singleton: true,

    get(reason) {
        var message = document.createElement('div'),
            html = {
                NoGeoUnit: 'There is no data for this variable for any<br>subgeographies of the selected location.',
                TooFewBinsException: 'The minimum number of bins is 2 and the bin size you entered generated<br>only 1 bin. Please decrease your bin size and try again.',
                TooManyBinsException: 'The maximum number of bins is 100 and the bin size you entered generated<br>more than 100 bins. Please increase your bin size and try again.',
                InsufficientDataForHistogramException: 'There is not enough data variability to generate a histogram.<br>Please change one or more settings above and try again.'
            }[reason];

        message.className = 'sa-histogram-no-data-view-message';
        message.innerHTML = html ?? 'An unexpected error occurred.';

        return SA.Html.create({
            type: 'div',
            class: 'sa-histogram-no-data-view',
            content: message
        });
    }
});